import { supplierIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const SupplierProductUpdate = z.object({
  productId: productIdFormat.schema,
  supplierProductTitle: z.string().nullable().optional(),
  supplierSku: z.string().nullable().optional(),
  unitCost: z.number().nullable().optional(),
  currency: z.string().nullable().optional(),
  leadTimeDays: z.number().int().min(0).nullable().optional(),
});
export type SupplierProductUpdate = z.infer<typeof SupplierProductUpdate>;

export const updateSupplierProducts = {
  name: "updateSupplierProducts" as const,
  input: z.object({
    supplierId: supplierIdFormat.schema,
    updates: z.array(SupplierProductUpdate).min(1),
  }),
  output: z.number().int(),
};
